<template>
  <vip-sonko-layout>
    <v-layout wrap class="mx-3">
      <vue-headful v-bind:title="expert.firstName" />
      <v-toolbar flat color="toolbarColor">
        <v-toolbar-title class="hidden-sm-and-down">Expert Portfolio</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat class="right" color="primary" @click="showRatingModal">Rate Expert</v-btn>
      </v-toolbar>

      <v-flex xs12 class="list-section mt-2 pa-2">
        <v-layout wrap>
          <v-flex md6 xs12><b>Name:</b> {{expert.firstName}} {{expert.lastName}}</v-flex>
          <v-flex md6 xs12><b>Phone:</b> {{expert.countryCode}}{{expert.phone}}</v-flex>
          <v-flex md6 xs12><b>Email:</b> {{expert.email}}</v-flex>
          <v-flex md6 xs12>
            <a v-if="expert.countryCode" :href="`https://wa.me/${expert.countryCode.replace('+','')}${expert.phone}`" target="_blank">
              <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
            </a>
            <a v-else :href="`https://wa.me/${expert.phone.replace('+','')}`" target="_blank">
              <img src="@/assets/whatsapp.png" style="width: 40px; height: 40px;" alt="">
            </a>
          </v-flex>
          <v-flex xs12><span class="red--text">Assigned Jobs:&nbsp;</span> <b>
            <router-link target="_blank" 
            :to="`/vip_sonko/expert/jobs/assigned/${expert._id}`">({{expert.jobCount}})</router-link></b></v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="list-section mt-2 pa-2">
        <h5>About The Expert</h5>        
        <div v-html="expert.bio"></div>
      </v-flex>
      <v-flex xs12 class="list-section mt-2 pa-2">
        <h5>Experience</h5>
        {{expert.experience}}
      </v-flex>
      <v-flex xs12 class="list-section mt-2 pa-2">
        <h5>Certificates(click to preview)</h5>
        <div v-if="expert.certificates">
          <v-layout wrap>
            <v-flex
              class="collection_thumbs"
              xs3
              sm1
              v-for=" (img, i) in expert.certificates"
              :key="i"
            >
              <img  v-if="img.name.split('.')[1].toLowerCase() != 'pdf'"
                class="thumb_image"
                @click="showImage(img.name)"
                :src="`${host}/uploads/certificates/${img.name}`"
                alt="thumbnail"
                style="height: 50px"
                title="Click to view"
              >
              <v-btn extrasmall v-if="img.name.split('.')[1].toLowerCase() == 'pdf'" class="ma-0 border-class" icon large :href="`${host}/uploads/certificates/${img.name}`" target="_blank">
                <v-icon style="height:auto;" >picture_as_pdf</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs12 class="list-section mt-2 pa-2">
        <h5>Projects</h5>
        <v-layout row wrap v-if="projects.length>=1">
          <v-flex xs12 sm6 v-for="project in projects" v-bind:key="project._id" class="mb-2">
            <v-card class="pa-3">
              <v-img v-if="project.coverImage != undefined" :src="`${host}/uploads/projects/${project.coverImage}`"></v-img>

              <v-card-title primary-title>
                <div>
                  <h4>{{project.title}}</h4>                  
                  <div v-html="trimText(project.description)"></div>
                </div>
              </v-card-title>

              <v-card-actions>
                <v-btn
                  flat
                  color="orange"
                  :to="`/sonko/project/details/${project._id}`"
                >More Details</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 class="list-section mt-2 pa-2" v-if="reviews && reviews.length>=1">
        <h5 class="mb-3">Reviews ({{reviewAmount}})</h5>
        <v-layout wrap v-if="reviews.length>=1">
          <v-flex xs12 v-for="review in reviews" v-bind:key="review._id" class="mb-4">
            <span v-if="review.sonkoId" class="green--text text--darken-1">{{review.sonkoId.firstName}} {{review.sonkoId.lastName}}</span>
            <span class="green--text text--darken-1" v-else>{{review.username}}</span>
            <br>
            {{review.review}}
            <br>
            <v-rating
              v-bind:value="Math.round(review.rating)"
              color="yellow darken-3"
              background-color="grey darken-1"
              empty-icon="$vuetify.icons.ratingFull"
              half-increments
              hover
              readonly
            ></v-rating>
          </v-flex>
          <v-flex>
            <v-pagination 
            v-model="currentPage"
            :length="Math.ceil(reviewAmount/perPage)"
            @input="onPageChange"
        ></v-pagination>
          </v-flex>
        </v-layout>
      </v-flex>
      
      <!-- image modal -->
      <v-dialog v-model="imageDialog" max-width="1200px">
        <v-card>
          <v-toolbar flat dense color="light-blue" dark>
            <v-toolbar-title class="title">Certificate preview</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="mb-2" @click.native="closeImage">
              <v-icon>clear</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <img class="modal-img" :src="`${host}/uploads/certificates/${currentImage}`">
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end of image modal -->

      <!-- rating modal -->
      <v-dialog v-model="ratingModal" max-width="500px">
        <v-card>
          <v-toolbar color="primary" flat dense dark>
            <v-toolbar-title class="title">Rate Expert</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" icon @click.native="ratingModal=false">
              <v-icon color="white">clear</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12>
                <v-rating
                  v-model="rating"
                  color="yellow darken-3"
                  background-color="grey darken-1"
                  empty-icon="$vuetify.icons.ratingFull"
                  half-increments
                  hover
                ></v-rating>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="review" label="Write a review"></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-btn color="btnColor" small dark @click="saveReview">
                  <v-icon>save</v-icon>save
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- rating modal -->
      

      <app-snackbar ref="mySnackbar"></app-snackbar>
    </v-layout>
  </vip-sonko-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { trimText } from "@/common/methods.js";
export default {
  name: "ExpertPortfolio",
  components: {},
  computed: {
    ...mapGetters(["host"]),
    ...mapGetters(["user"])
  },
  data() {
    return {
      rating: 0.0,
      review: null,
      ratingModal: false,
      expert: {},
      reviews: [],
      projects: [],
      imageDialog: false,
      currentImage: null,
      reviewAmount: 0,
      currentPage: typeof this.$route.query.page != "undefined" ? this.$route.query.page : 1,
      perPage: 8
    };
  },
  methods: {
    trimText,
    showImage(img) {
      this.currentImage = img;
      this.imageDialog = true;
    },
    showRatingModal() {
      this.ratingModal = true;
    },
    saveReview() {
      if(this.rating <= 0) {
        this.$refs.mySnackbar.show("Please give an X/5 Stars Rating", "red");
      } else if (this.review == null) {
        this.$refs.mySnackbar.show("Please fill in review", "red");
      } else {
        const data = {
          rating: this.rating,
          review: this.review,
          expertId: this.expert._id,
          sonkoId: this.user._id
        };

        const self = this;
        const res = this.$store
          .dispatch("post", { url: "/review/expert", data })
          .then(res => {
            self.rating = 0.0;
            self.$refs.mySnackbar.show("Review Successful", "blue");
            self.ratingModal = false;
          });
      }
    },
    closeImage() {
      this.imageDialog = false;
    },
    getExpert() {
      const id = this.$route.params.id;
      this.$store.dispatch("get", "/user/expert/" + id).then(res => {
        this.expert = res.expert;
      });
    },
    getReviews() {
      let cPage = typeof this.$route.query.page != "undefined"
        ? this.$route.query.page
        : 1;
      const id = this.$route.params.id;
      this.$store.dispatch("get", "/review/expert/" + id+"/"+cPage).then(res => {
        this.reviews = res.reviews;
        this.reviewAmount = res.amount;
        this.currentPage = cPage;
      });
    },
    getProjects() {
      const id = this.$route.params.id;
      this.$store.dispatch("get", "/project/getall/" + id).then(res => {
        this.projects = res.projects;
      });
    },
    onPageChange(page) {
      this.$router.push({query: {page: page}});
      this.getReviews();
    }
  },
  mounted() {
    this.getReviews();
  },
  created() {
    this.getExpert();
    this.getReviews();
    this.getProjects();
  }
};
</script>

<style scoped>
.collection_thumbs {
  overflow: hidden;
  max-height: 120px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 2px;
  text-align: center;
}
.collection_thumbs img {
  max-height: 100%;
  max-width: 100%;
}
.thumb_image:hover {
  text-align: center;
  content: "Click to remove";
  cursor: pointer;
}
</style>
